module.exports = __webpack_public_path__ + "static/desarrollo-6a778f60f80e51f6c6fe77face8873cb.png";